module.exports = __webpack_public_path__ + "img/MLOGO_red_3rgb.60e348b3.svg";